/* Surisa <header-cta-slot> — el slot del header desktop conmuta entre el
   buscador (por defecto) y los CTAs activos de la landing cuando el
   usuario cruza .scrolled-past-header (clase que añade StickyHeader al
   .section-header al bajar y quita al volver al top).

   Contrato del evento (lo emite snippets/mobile-sticky-ctas.liquid en
   cada landing que renderiza el sticky bar mobile):

     document.dispatchEvent(new CustomEvent('landing:ctas-ready', {
       detail: {
         ctas: [
           { id, url, label, sublabel },
           ...
         ],
         main_id: 'catalog' | 'pdf' | 'consulta'
       }
     }))

   Sin evento → la cara CTAs queda vacía y el slot no añade la clase
   --has-ctas, así que el buscador sigue visible siempre (homepage,
   producto, blog…). La transición opacity la maneja el CSS. */

(function () {
  var ICONS = {
    catalog:
      '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/></svg>',
    pdf:
      '<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8z"/><path d="M14 3v5h5"/></svg>',
    consulta:
      '<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="5" width="18" height="14"/><path d="M3 7l9 6 9-6"/></svg>'
  };

  function makeIconSpan(id) {
    var span = document.createElement('span');
    span.className = 'surisa-header__cta-icon';
    span.setAttribute('aria-hidden', 'true');
    // SVGs are authored in this file; safe to use innerHTML. Text content
    // (label, sublabel, aria-label) goes through textContent/setAttribute
    // below so it never gets HTML-interpreted.
    span.innerHTML = ICONS[id] || '';
    return span;
  }

  /* Liquid's `| json` filter HTML-encodes <, >, & to &lt; &gt; &amp; before
     injecting strings into inline <script> tags (defensa anti-XSS de
     Shopify, ver el caso real con el sublabel "Respuesta < 6h"). Cuando
     el JS parsea el payload, el valor llega ya con entities literales en
     vez del caracter raw. Decodificamos en el boundary para que el
     textContent muestre el caracter real, no la entidad escapada. Usa
     <textarea> (RCDATA) que decodifica entities sin interpretar tags. */
  var entityDecoder = document.createElement('textarea');
  function decodeEntities(s) {
    if (s == null) return '';
    entityDecoder.innerHTML = String(s);
    return entityDecoder.value;
  }

  function makeTextSpan(className, text) {
    var span = document.createElement('span');
    span.className = className;
    span.textContent = text == null ? '' : String(text);
    return span;
  }

  function normalizeCta(c) {
    return {
      id: c.id,
      url: decodeEntities(c.url),
      label: decodeEntities(c.label),
      sublabel: decodeEntities(c.sublabel)
    };
  }

  // Las URLs externas (http/https) abren en pestaña nueva, igual que el PDF,
  // para no sacar al usuario del site de la tienda.
  function isExternalUrl(url) {
    return /^https?:/i.test(url || '');
  }

  function makeMain(c) {
    var a = document.createElement('a');
    a.href = c.url;
    a.className = 'surisa-header__cta surisa-header__cta--main';
    if (c.id === 'pdf' || isExternalUrl(c.url)) {
      a.target = '_blank';
      a.rel = 'noopener';
    }
    a.appendChild(makeIconSpan(c.id));

    // Solo título (sin sublabel): el CTA que sube al header al hacer scroll
    // muestra únicamente el copy principal del CTA, no la línea secundaria
    // ("Medidas y stock", "Respuesta < 6h", …) que sí lleva la barra sticky
    // móvil. El stack se mantiene por consistencia de layout/estilos.
    var stack = document.createElement('span');
    stack.className = 'surisa-header__cta-label-stack';
    stack.appendChild(makeTextSpan('surisa-header__cta-label', c.label));
    a.appendChild(stack);
    return a;
  }

  function makeTile(c) {
    var a = document.createElement('a');
    a.href = c.url;
    a.className = 'surisa-header__cta surisa-header__cta--tile';
    if (c.id === 'pdf' || isExternalUrl(c.url)) {
      a.target = '_blank';
      a.rel = 'noopener';
    }
    if (c.label) a.setAttribute('aria-label', c.label);
    a.appendChild(makeIconSpan(c.id));
    a.appendChild(makeTextSpan('surisa-header__cta-label', c.label));
    return a;
  }

  class HeaderCtaSlot extends HTMLElement {
    connectedCallback() {
      this.ctasFace = this.querySelector('[data-slot-content="ctas"]');
      this.onLandingCtas = this.onLandingCtas.bind(this);
      document.addEventListener('landing:ctas-ready', this.onLandingCtas);
    }

    disconnectedCallback() {
      document.removeEventListener('landing:ctas-ready', this.onLandingCtas);
    }

    onLandingCtas(event) {
      var detail = (event && event.detail) || {};
      var rawCtas = Array.isArray(detail.ctas) ? detail.ctas : [];
      if (!rawCtas.length || !this.ctasFace) return;

      var ctas = rawCtas.map(normalizeCta);
      var mainId = detail.main_id || ctas[0].id;
      var main = null;
      for (var i = 0; i < ctas.length; i++) {
        if (ctas[i].id === mainId) { main = ctas[i]; break; }
      }
      if (!main) main = ctas[0];

      var tiles = ctas.filter(function (c) { return c.id !== main.id; });

      var nav = document.createElement('nav');
      nav.className = 'surisa-header__ctas';
      nav.setAttribute('aria-label', 'Acciones rápidas');
      nav.appendChild(makeMain(main));
      tiles.forEach(function (c) { nav.appendChild(makeTile(c)); });

      this.ctasFace.replaceChildren(nav);
      this.ctasFace.setAttribute('aria-hidden', 'false');
      this.classList.add('surisa-header__cta-slot--has-ctas');
    }
  }

  customElements.define('header-cta-slot', HeaderCtaSlot);
})();
